<template>
  <div class="w-100">
    <div class="row p-0 acry-text-body text-start m-auto" style="width: 550px; font-size: 15px;">
      <p class="m-0">パスワードを変更します。</p>
      <p class="m-0">次回ログイン時より、新しいパスワードが適用されますのでご注意下さい。</p>
    </div>

    <div class="row pt-4 m-auto" style="width:400px;">
      <p class="acry-text-title text-start p-0 mb-2">新しいパスワード</p>
      <form class="p-0" onsubmit="return false;">
        <input class="w-100 acry-input" :class="{'input-error':this.error1}" type="password" placeholder="半角英数字6文字以上" v-model="pass1" required />
      </form>
      <p class="acry-text-body acry-error-text text-start p-0" style="font-size: 14px;">{{this.error1}}</p>
    </div>

    <div class="row pt-1 m-auto" style="width:400px;">
      <p class="acry-text-title text-start p-0 mb-2">新しいパスワード：再入力</p>
      <form class="p-0" onsubmit="return false;">
        <input class="w-100 acry-input" :class="{'input-error':this.error2}" type="password" placeholder="半角英数字6文字以上" v-model="pass2" required />
      </form>
      <p class="acry-text-body acry-error-text text-start p-0" style="font-size: 14px;">{{this.error2}}</p>
    </div>

    <button class="acry-btn-primary-normal fw-bold m-2" style="width:250px; height:56px;" @click="changePassword()">パスワードを変更</button>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";
import { User } from "@/js/User.js";

export default {
  name: "CenterViewShippingPassword_Ap",
  props: {},
  data() {
    return {
      pass1: "",
      pass2: "",
      error1: "",
      error2: "",
    };
  },

  methods: {
    async changePassword() {
      this.error1 = "";
      this.error2 = "";

      if( this.pass1 != this.pass2 ){
        this.error2 = "上記とパスワードが異なります";
        return;
      }

      if( this.pass1.length < 6 ){
        this.error1 = "半角英数字6文字以上入力してください";
        return;
      }

      if( User.credential ){
        await firebase.auth().signInWithCredential( User.credential );
      }

      firebase.auth().currentUser.updatePassword(this.pass1).then(() => {
        this.$store.commit("showMessage", "パスワードを変更しました");
      }).catch((error) => {
        //this.$store.commit("showMessage", "エラーが発生しました");
        this.$handleError("052", error, { message: "エラーが発生しました。\n左下メニューからログアウトしてから再度ログインし、\nもう一度お試しください。" });
      });
    }

  },
};
</script>
<style scoped lang="scss">
.input-error{
  border: 1px solid $status-error-color;
  background: #FFF6F6;
}

</style>
